import ErrorBoundary, { withErrorBoundary } from './ErrorBoundary'
import FallbackComponent from './FallbackComponent'
export { FallbackComponent }
export default ErrorBoundary
const __withErrorBoundary = withErrorBoundary
export { __withErrorBoundary as withErrorBoundary }

